var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0033AD",
    d: "M2.284 22.158c.001.95.679 1.752 1.62 1.792c1.31.055 2.623.022 3.935.022c.954 0 1.786-.865 1.76-1.954c-.029-1.221.018-2.445.029-3.667l.045-4.988c.003-.305.046-.362.335-.44a4.242 4.242 0 0 1 2.013-.067c1.23.262 2.129 1.21 2.261 2.46c.066.62.07 1.249.078 1.874c.025 1.64.038 3.28.054 4.921c.01 1.087.796 1.877 1.883 1.882c1.171.006 2.342.008 3.513.007c1.106-.002 1.895-.778 1.898-1.883c.007-3.371.007-6.742.01-10.113c0-.052 0-.105-.005-.156c-.03-.355-.169-.658-.483-.838a2.638 2.638 0 0 0-.695-.291a7.484 7.484 0 0 0-2.887-.123c-.743.113-1.476.293-2.213.442c-.97.196-1.946.28-2.934.178c-1.268-.129-2.37-.666-3.402-1.38a32.36 32.36 0 0 0-1.494-.984c-.62-.38-1.314-.505-2.03-.544c-.77-.043-1.536-.063-2.293.111c-.59.136-.899.479-.966 1.077a3.438 3.438 0 0 0-.021.379m7.337-6.184a3.675 3.675 0 1 0-7.35-.031a3.675 3.675 0 0 0 7.35.03zm8.335-1.81a3.673 3.673 0 0 0-3.69 3.652a3.672 3.672 0 0 0 3.67 3.697a3.678 3.678 0 0 0 3.68-3.665a3.677 3.677 0 0 0-3.66-3.685Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.1590a558a88370b71e1579ce58c3a60f.svg";
export { ForwardRef as ReactComponent };